import { makeStyles, Typography } from '@material-ui/core';
import React from 'react';
import { useHistory } from 'react-router-dom';
import GoogleButtonImg from '../../../public/icons/google.svg';
import LinksButtonImg from '../../../public/icons/links.svg';
import { Page } from '../../components/Page';
import { EmailLogin } from './EmailLogin';
import { SignInActionButton } from './SignInActionButton';
import { useCookies } from 'react-cookie';

const TERMS_URL = 'https://jupiterone.com/terms/';
const PRIVACY_POLICY_URL = 'https://jupiterone.com/privacy-policy/';

const LOGOUT_REASON_COOKIE_NAME = 'j1-logout-reason';

const useStyles = makeStyles(() => ({
  agreementMessage: {
    marginTop: '1rem',
    textAlign: 'center',
    fontSize: '0.9rem',
    color: 'rgba(0, 0, 0, 0.54)',
  },
}));

export function LoginForm() {
  const classes = useStyles();
  const googleButtonUrl = GoogleButtonImg
  const linksButtonURL = LinksButtonImg

  const history = useHistory();

  // logout reason message passed through cookies
  const [cookies] = useCookies([LOGOUT_REASON_COOKIE_NAME]);

  const handleGoogleLogin = () => {
    document.location.replace(
      `/auth/google/authorize${window.location.search}`,
    );
  };

  const handleGetLinksToAccounts = () => {
    history.push('/forgot-sso');
  };

  return (
    <Page
      title="Sign In"
      message={
        cookies[LOGOUT_REASON_COOKIE_NAME] === 'sessionTimeout'
          ? 'Your session has timed out. Please sign in again.'
          : null
      }
      rightColumn={
        <>
          <SignInActionButton
            label="Sign in with Google"
            icon={googleButtonUrl}
            onClick={handleGoogleLogin}
          />
          <SignInActionButton
            label="Get links to your accounts"
            icon={linksButtonURL}
            onClick={handleGetLinksToAccounts}
          />
        </>
      }
    >
      <EmailLogin />
      <Typography className={classes.agreementMessage}>
        By logging in you are agreeing to JupiterOne&apos;s <br />
        <a
          href={TERMS_URL}
          target="_blank"
          rel="noreferrer"
          style={{ color: 'rgba(11, 57, 127, 0.781)', textDecoration: 'none' }}
        >
          Terms and Conditions
        </a>{' '}
        &{' '}
        <a
          href={PRIVACY_POLICY_URL}
          target="_blank"
          rel="noreferrer"
          style={{ color: 'rgba(11, 57, 127, 0.781)', textDecoration: 'none' }}
        >
          Privacy Policy
        </a>
      </Typography>
    </Page>
  );
}
